import React, { useEffect, useState } from 'react'
import api from '../../config/api'
import { useParams, useLocation } from 'react-router-dom'
import { Container } from './styles'


import { Snackbar, Typography } from '@material-ui/core';
import TransferList from '../../components/TrasferList';
import { Alert } from '@material-ui/lab';
import Loading from '../../components/Loading';
import UpdateStock from '../../components/UpdateStock';
import { callbackify } from 'util';


interface Stock {
    id: number
    branch_id: number
    product_id: number
    description: string
    quantity: number
    product: Product
}

interface Product {
    id: number
    name: string
    description: string
    value: number
    image: string
}

function StockDetail() {
    
    //@ts-ignore
    const { id } = useParams()
    const location = useLocation()

    //@ts-ignore
    const city = location.state.city

    const [stocks, setStocks] = useState<Stock[]>([])

    const [included, setIncluded] = useState<Product[]>([])
    const [notIncluded, setNotIncluded] = useState<Product[]>([])

    const [includedCopy, setIncludedCopy] = useState<Product[]>([])
    const [notIncludedCopy, setNotIncludedCopy] = useState<Product[]>([])

    const [openSuccess, setOpenSuccess] = useState(false);


    const [loading, setLoading] = useState(false)
    const [loadingStock, setLoadingStock] = useState(false)

    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSuccess(false);
    };



    async function handleUpdate(left: any, right: any) {
        setLoadingStock(true)

        try {
            const difNotIncluded = notIncluded.filter(product => !notIncludedCopy.includes(product)).map(({ id }) => id)
            const difIncluded = included.filter(product => !includedCopy.includes(product)).map(({ id }) => id)

            if (difNotIncluded.length > 0) {
                await api.delete(`/stocks/deletebatch/${id}`,
                    {
                        data: {
                            products: difNotIncluded
                        }
                    })
            }
            if (difIncluded.length > 0) {
                await api.post('/stocks/batch', {
                    products: difIncluded,
                    branch_id: id
                })
            }
            await fetch()
            setOpenSuccess(true)
            setLoadingStock(false)
        } catch (err) {
            console.log(err)
        }
    }


    async function fetch() {

        const responseStocks = await api.get(`/stocks/${id}`)
        const responseProducts = await api.get('/products')


        const auxIncluded = responseStocks.data.stocks.map((stock: Stock) => {
            return stock.product
        }) as Product[]



        const auxNotIncluded = responseProducts
            .data.products.filter((product: Product) =>
                !auxIncluded.find(product_2 => product.id === product_2.id)
            )


        setIncluded(auxIncluded)
        setNotIncluded(auxNotIncluded)

        setIncludedCopy(auxIncluded)
        setNotIncludedCopy(auxNotIncluded)

        setStocks(responseStocks.data.stocks)
        setLoading(false)
    }

    useEffect(() => {
        setLoading(true)
        fetch()
        //getProductDispatch()
    }, [])





    return (
        <Container>
            {
                loading ?
                    <Loading />
                    :
                    <>
                        <Typography variant="h4" style={{ marginBottom: 20, fontWeight: 600 }}>
                            Produtos disponiveis em {city}
                        </Typography>
                        <TransferList left={notIncluded} right={included} setLeft={setNotIncluded} setRight={setIncluded} handleUpdate={handleUpdate} />

                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 20, marginBottom: 20 }}>
                            <Typography variant="h4" style={{ margin: '10px 0px' }}>
                                Estoque de {city}
                            </Typography>
                        </div>
                        {
                            loadingStock ?
                                <Loading />
                                :
                                //@ts-ignore
                                <UpdateStock stocks={stocks} branch={id} />
                        }
                        <Snackbar open={openSuccess} autoHideDuration={2000} onClose={handleCloseSuccess}>
                            <Alert onClose={handleCloseSuccess} severity="success">
                                Produtos disponiveis atualizados!
                            </Alert>
                        </Snackbar>
                    </>

            }
        </Container>
    );
}

export default StockDetail